import Repository from '@/api/core'
const baseURL = process.env.VUE_APP_API_OFFLINE_EVALUATION + '/evaluation-collection'

const fetch = (params) => {
  return Repository(baseURL).fetch(params)
}

const fetchOne = (id) => {
  return Repository(baseURL).fetchOne(id)
}

const create = (params) => {
  return Repository(baseURL).create(params)
}

const update = (id, params) => {
  return Repository(baseURL).update(id, params)
}

const remove = (id) => {
  return Repository(baseURL).delete(id)
}

const sendMailAndNotify = (params, options) => {
  return Repository(baseURL + '/send-mail').create(params, options)
}

export default {
  fetch,
  fetchOne,
  create,
  update,
  remove,
  sendMailAndNotify,
}
